export {
  default as PlayerProfileDetail,
  type PlayerProfileDetailProps,
  type PlayerProfileDetailRow,
} from './player-profile-detail';
